import React, { useMemo } from 'react'
import { MenuItem, TextField } from '@material-ui/core'
import {
  HourSeriesCollectionFragment,
  HourSeriesFragment,
} from '../../generated/graphql'

export type HourSeriesSelectProps = {
  name: string
  value: string | null
  collections: HourSeriesCollectionFragment[]
  id?: string
  label?: string
  error?: string
  allowEmpty?: boolean
  filter?: (hourSeries: HourSeriesFragment) => boolean
  onChange: (value: string | null) => void
}

export function HourSeriesSelect({
  name,
  value,
  collections,
  id,
  label,
  error,
  allowEmpty,
  filter,
  onChange,
}: HourSeriesSelectProps): React.ReactElement {
  const filteredCollections = useMemo(
    () =>
      collections.map((collection) => ({
        ...collection,
        hourSeries: collection.hourSeries.filter((hourSeries) =>
          filter ? filter(hourSeries) : true,
        ),
      })),
    [collections, filter],
  )

  return (
    <TextField
      name={name}
      id={id}
      label={label}
      error={error !== undefined}
      helperText={error}
      value={value ?? ''}
      onChange={(event) =>
        onChange(event.target.value !== '' ? event.target.value : null)
      }
      select
    >
      {allowEmpty && (
        <MenuItem value="" selected={value === null}>
          -
        </MenuItem>
      )}
      {filteredCollections.flatMap((collection) =>
        collection.hourSeries.map((hourSeries) => (
          <MenuItem key={hourSeries.id} value={hourSeries.id}>
            {collection.name} &rsaquo; {hourSeries.name}
          </MenuItem>
        )),
      )}
    </TextField>
  )
}
